import * as React from 'react';
import { connect } from 'react-redux';
import checkoutOnShopify from '../../../../shopify_checkout';

const mapStateToProps = state => ({
   products: state.headerState.miniCart.products,
});

const Footer = ({ products }) => {
   const checkoutButtonAttributes = App.shopifyCheckout
      ? {
           onClick: e => {
              checkoutOnShopify();
              e.preventDefault();
           },
        }
      : {
           href: window.shared_constants.CartURI('NEW_PLACE_ORDER'),
        };

   return products.length ? (
      <div className="mini-cart-footer">
         <a
            className="mini-cart-button button button-transparent"
            href={window.shared_constants.BaseURI('TAG_CHECKOUT_CART')}
         >
            {_js('View Cart')}
         </a>
         <a
            className="mini-cart-button button button-action-solid js-check-out-fb-track-button"
            {...checkoutButtonAttributes}
         >
            {_js('Check Out')}
         </a>
      </div>
   ) : (
      <div className="mini-cart-footer">
         <a
            className="mini-cart-button button button-action-solid"
            href={window.shared_constants.BaseURI('STORE')}
         >
            {_js('Browse Our Store')}
         </a>
      </div>
   );
};

export default connect(mapStateToProps)(Footer);
